import React, { type ReactNode } from "react";

import { SupText } from "../../../../components/UI/Text";

interface CellProps {
  content: ReactNode;
}

export function Cell({ content }: CellProps) {
  return typeof content === "string" ? (
    <SupText as="span" variant="body1" family="mono">
      {content}
    </SupText>
  ) : (
    content
  );
}
